import {
  BenefitDTOBenefitEnum,
  BikeleasingV2BenefitDetailsDTO,
  BikeleasingV2ConditionDTO,
  BikeleasingV2ContractsListDTO,
} from 'probonio-shared-ui/api';
import { apis, useEmployeeQuery } from 'probonio-shared-ui/module/api';
import { useTenantID } from 'probonio-shared-ui/module/me';
import { useMemo } from 'react';
import { useActiveBenefitsQuery } from '../bikeleasing/useActiveBenefitsQuery';

export function useBikeleasingDetails(): BikeleasingV2BenefitDetailsDTO | undefined {
  const { data } = useActiveBenefitsQuery();
  // const translateBoolean = useCallback((bool?: boolean) => t(`common:${bool}`), [t]);
  return useMemo(() => {
    return data?.benefits.find(benefit => benefit.benefit === BenefitDTOBenefitEnum.BikeleasingV2)
      ?.details as BikeleasingV2BenefitDetailsDTO;
  }, [data]);
}

/**
 * The employer is not a bikeleasing customer yet: the benefit stays visible but cannot be used.
 * leasingEnabled is the source of truth; the empty condition is only kept as a fallback, because the
 * API still returns one for app installations that depend on that field. A real condition always
 * carries the employer's companyCode.
 */
export function isBikeleasingSetupPending(details: BikeleasingV2BenefitDetailsDTO | undefined): boolean {
  return !!details && (!details.leasingEnabled || !details.bikeleasingCondition?.companyCode);
}

export function useBikeleasingContracts(): BikeleasingV2ContractsListDTO | undefined {
  const { data } = useEmployeeQuery(['benefit', 'bikeleasing', 'contracts'], params =>
    apis.employee
      .listContracts({
        ...params,
      })
      .then(res => res.data),
  );
  return data;
}

export function useBikeleasingCondition(): BikeleasingV2ConditionDTO | undefined {
  const getTenantId = useTenantID();

  const { data } = useEmployeeQuery(['benefit', 'bikeleasingV2', 'condition'], params =>
    apis.bikeLeasingV2
      .getCondition({
        tenantId: getTenantId(),
      })
      .then(res => res.data),
  );
  return data?.condition ?? undefined;
}
